
import { IManufacturingPlan } from '@/utils/types/barcodeTypes'
import dayjs from 'dayjs'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'ManufacturingPlanDialog',
  emits: ['update:modelValue', 'update:lotNumber', 'begin', 'close'],
})
export default class ManufacturingPlanDialog extends Vue {
  @Prop({ type: Boolean, default: false }) modelValue!: boolean
  @Prop({ required: true }) manufacturingPlan!: IManufacturingPlan
  @Prop({ type: String, default: '' }) lotNumber!: string

  get formattedCompletionDate(): string {
    if (!this.manufacturingPlan?.manufactureCompletionDate) return ''
    const format = this.$t('date_format')
    return dayjs(new Date(this.manufacturingPlan.manufactureCompletionDate)).format(format)
  }

  handleLotNumberInput(event: Event) {
    const target = event.target as HTMLInputElement
    this.$emit('update:lotNumber', target.value)
  }

  handleBegin() {
    this.$emit('begin')
  }

  handleClose() {
    this.$emit('close')
  }
}
